/* MASTERPIECE — MPX runtime (rails, feeds, quick add, wishlist, recently viewed, search) */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  html.classList.add('mpx-on');
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var EMOJI = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}\u{20E3}\u{1F1E6}-\u{1F1FF}]/gu;
  function clean(t) { return (t || '').replace(EMOJI, '').replace(/\s{2,}/g, ' ').replace(/^[\s\-–|·]+|[\s\-–|·]+$/g, '').trim(); }
  function toast(msg) {
    var t = d.querySelector('.mpx-toast');
    if (!t) { t = d.createElement('div'); t.className = 'mpx-toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }

  /* ---------- header: shrink + hide on scroll down ---------- */
  function header() {
    var last = 0, tick = false;
    function upd() {
      var y = w.scrollY;
      html.classList.toggle('mpx-scrolled', y > 24);
      html.classList.toggle('mpx-hide-header', y > 420 && y > last + 4 && !html.classList.contains('mpx-lock'));
      if (y < last - 4) html.classList.remove('mpx-hide-header');
      last = y; tick = false;
      var h = d.querySelector('[id*="__header"].shopify-section');
      var top = h && !html.classList.contains('mpx-hide-header') ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
      html.style.setProperty('--mpx-sticky-top', top + 'px');
    }
    w.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---------- rails ---------- */
  function rail(root) {
    if (root._mpx) return; root._mpx = 1;
    var tr = root.querySelector('.mpx-rail__track'); if (!tr) return;
    var prev = root.querySelector('[data-rail-prev]'), next = root.querySelector('[data-rail-next]'), bar = root.querySelector('.mpx-rail__bar i');
    function step() { var c = tr.children[0]; return c ? (c.getBoundingClientRect().width + parseFloat(getComputedStyle(tr).columnGap || 16)) * Math.max(1, Math.floor(tr.clientWidth / (c.getBoundingClientRect().width || 1)) - 0) : tr.clientWidth; }
    function upd() {
      var max = tr.scrollWidth - tr.clientWidth;
      if (prev) prev.disabled = tr.scrollLeft < 4;
      if (next) next.disabled = tr.scrollLeft > max - 4;
      if (bar) { var r = tr.clientWidth / tr.scrollWidth; bar.style.setProperty('--w', Math.min(100, r * 100) + '%'); bar.style.setProperty('--x', (max > 0 ? (tr.scrollLeft / max) * (1 / r - 1) * 100 : 0) + '%'); }
    }
    prev && prev.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    next && next.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    tr.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    w.addEventListener('resize', upd); root._upd = upd; upd();
  }

  /* ---------- product feeds (lazy, tabbed) ---------- */
  var cache = {};
  function skel(n) { var s = ''; for (var i = 0; i < n; i++) s += '<div class="mpx-card mpx-card--skel" aria-hidden="true"><div class="mpx-card__media"></div><div class="mpx-card__info"><i style="width:40%"></i><i style="width:80%"></i><i style="width:30%"></i></div></div>'; return s; }
  function load(feed, url) {
    var tr = feed.querySelector('.mpx-rail__track, .mpx-pgrid'); if (!tr) return;
    var lim = +feed.dataset.limit || 12;
    var done = function (h) {
      var tmp = d.createElement('div'); tmp.innerHTML = h;
      var cards = tmp.querySelectorAll('.mpx-card'), out = '';
      for (var i = 0; i < cards.length && i < lim; i++) out += cards[i].outerHTML;
      tr.innerHTML = out || '<div class="mpx-empty">New pieces are landing soon — browse the full collection.</div>';
      cards_(tr); var r = feed.querySelector('.mpx-rail'); r && r._upd && r._upd(); tr.scrollLeft = 0;
    };
    if (cache[url]) return done(cache[url]);
    tr.innerHTML = skel(Math.min(lim, 4));
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) { cache[url] = h; done(h); }).catch(function () { tr.innerHTML = '<div class="mpx-empty">Could not load products. <a href="' + url.split('?')[0] + '">View collection →</a></div>'; });
  }
  function feeds(root) {
    (root || d).querySelectorAll('[data-mpx-feed]').forEach(function (feed) {
      if (feed._mpx) return; feed._mpx = 1;
      var tabs = feed.querySelectorAll('[data-feed-url]'), more = feed.querySelector('[data-feed-more]');
      function pick(btn) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === btn ? 'true' : 'false'); });
        load(feed, btn.dataset.feedUrl);
        if (more && btn.dataset.feedMore) { more.href = btn.dataset.feedMore; if (btn.dataset.feedMoreLabel) more.querySelector('[data-label]').textContent = btn.dataset.feedMoreLabel; }
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { pick(t); }); });
      var first = feed.querySelector('[data-feed-url][aria-selected="true"]') || tabs[0];
      if (!first) return;
      if (!('IntersectionObserver' in w)) return pick(first);
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); pick(first); } }, { rootMargin: '600px 0px' });
      io.observe(feed);
    });
  }

  /* ---------- cards: titles, wishlist, quick add ---------- */
  function wishSync(root) {
    var list = store.get('mpx:wish');
    (root || d).querySelectorAll('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.dataset.wish) > -1 ? 'true' : 'false'); });
  }
  function cards_(root) {
    (root || d).querySelectorAll('.mpx-card__title[data-raw]').forEach(function (el) {
      var t = clean(el.dataset.raw).split(/\s[–—|]\s|\s-\s/)[0];
      var b = el.closest('.mpx-card').querySelector('.mpx-card__brand');
      if (b && b.textContent && t.toLowerCase().indexOf(b.textContent.trim().toLowerCase()) === 0) t = t.slice(b.textContent.trim().length).trim();
      el.textContent = t || clean(el.dataset.raw); el.removeAttribute('data-raw');
    });
    wishSync(root);
  }
  function refreshCart() {
    var sec = d.querySelector('.shopify-section[id$="__cart-drawer"], #shopify-section-cart-drawer');
    var sid = sec ? sec.id.replace('shopify-section-', '') : null;
    var p = fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      d.querySelectorAll('cart-count, .cart-count, [data-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.hidden = c.item_count === 0; });
      d.dispatchEvent(new CustomEvent('mpx:cart', { detail: c }));
    });
    if (!sid) return p.then(function () { return false; });
    return fetch(ROOT + '?section_id=' + encodeURIComponent(sid)).then(function (r) { return r.text(); }).then(function (h) {
      var tmp = d.createElement('div'); tmp.innerHTML = h;
      var fresh = tmp.querySelector('cart-drawer'), cur = d.querySelector('cart-drawer');
      if (fresh && cur) {
        ['cart-items', '.cart-drawer__footer', '.drawer__footer', 'form[action*="/cart"]'].some(function (s) {
          var a = cur.querySelector(s), b = fresh.querySelector(s); if (a && b) { a.replaceWith(b); return true; } return false;
        });
      }
      return true;
    });
  }
  function openCart() {
    var t = d.querySelector('[aria-controls="CartDrawer"]');
    if (t) { t.click(); return; }
    var cd = d.querySelector('cart-drawer');
    if (cd && typeof cd.show === 'function') { cd.show(); return; }
    w.location.href = ROOT + 'cart';
  }
  function add(card, id, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { card.classList.add('is-added'); setTimeout(function () { card.classList.remove('is-added'); }, 1600); var s = card.querySelector('.mpx-card__sizes'); s && s.classList.remove('is-open'); return refreshCart(); })
      .then(function () { openCart(); })
      .catch(function (e) { toast((e && (e.description || e.message)) || 'Could not add — please try again'); })
      .finally(function () { btn && btn.removeAttribute('aria-busy'); });
  }
  d.addEventListener('click', function (e) {
    var wb = e.target.closest('[data-wish]');
    if (wb) {
      e.preventDefault(); var list = store.get('mpx:wish'), h = wb.dataset.wish, i = list.indexOf(h);
      if (i > -1) { list.splice(i, 1); toast('Removed from saved'); } else { list.unshift(h); list = list.slice(0, 60); toast('Saved — find it under Continue shopping'); }
      store.set('mpx:wish', list); wishSync(); return;
    }
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault(); var card = qa.closest('.mpx-card'); var vs = [];
      try { vs = JSON.parse(card.querySelector('script[data-variants]').textContent); } catch (x) {}
      var avail = vs.filter(function (v) { return v.a; });
      if (vs.length <= 1) { if (avail[0]) add(card, avail[0].id, qa); else toast('Sold out'); return; }
      var s = card.querySelector('.mpx-card__sizes'); s && s.classList.toggle('is-open'); return;
    }
    var sz = e.target.closest('[data-variant-id]');
    if (sz && sz.closest('.mpx-card__sizes')) { e.preventDefault(); add(sz.closest('.mpx-card'), sz.dataset.variantId, sz); return; }
    var cl = e.target.closest('[data-sizes-close]');
    if (cl) { e.preventDefault(); cl.closest('.mpx-card__sizes').classList.remove('is-open'); }
  });

  /* ---------- explorer group filter ---------- */
  function explorer() {
    d.querySelectorAll('[data-mpx-explorer]').forEach(function (ex) {
      if (ex._mpx) return; ex._mpx = 1;
      var btns = ex.querySelectorAll('[data-group-btn]'), items = ex.querySelectorAll('[data-group]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
          var g = b.dataset.groupBtn;
          items.forEach(function (it) { it.hidden = !(g === 'all' || it.dataset.group === g); });
          var r = ex.querySelector('.mpx-rail'); if (r) { r.querySelector('.mpx-rail__track').scrollLeft = 0; r._upd && r._upd(); }
        });
      });
    });
  }

  /* ---------- recently viewed + saved ---------- */
  function trackView() {
    var h = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!h) return; h = decodeURIComponent(h);
    var list = store.get('mpx:rv').filter(function (x) { return x !== h; }); list.unshift(h); store.set('mpx:rv', list.slice(0, 20));
  }
  function recent() {
    d.querySelectorAll('[data-mpx-recent]').forEach(function (sec) {
      if (sec._mpx) return; sec._mpx = 1;
      var tr = sec.querySelector('.mpx-rail__track'), tabs = sec.querySelectorAll('[data-recent-src]');
      var cur = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1]; cur = cur && decodeURIComponent(cur);
      function show(src) {
        var list = store.get(src).filter(function (h) { return h !== cur; }).slice(0, +sec.dataset.limit || 8);
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.recentSrc === src ? 'true' : 'false'); });
        if (!list.length) { tr.innerHTML = '<div class="mpx-empty">' + (src === 'mpx:wish' ? 'Tap ♡ on any piece to save it here.' : 'Pieces you view will appear here.') + '</div>'; return; }
        tr.innerHTML = skel(Math.min(4, list.length));
        Promise.all(list.map(function (h) { return fetch(ROOT + 'products/' + encodeURIComponent(h) + '?view=mpx-card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }); }))
          .then(function (arr) { tr.innerHTML = arr.join('') || '<div class="mpx-empty">Nothing here yet.</div>'; cards_(tr); var r = sec.querySelector('.mpx-rail'); r && r._upd && r._upd(); });
      }
      var rv = store.get('mpx:rv').filter(function (h) { return h !== cur; }), wl = store.get('mpx:wish');
      if (!rv.length && !wl.length && !(w.Shopify && w.Shopify.designMode)) { sec.hidden = true; return; }
      sec.hidden = false;
      tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.recentSrc); }); });
      show(rv.length ? 'mpx:rv' : 'mpx:wish');
    });
  }

  /* ---------- search overlay ---------- */
  var S = null, sTimer = 0, sCtl = null;
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function hl(t, q) { var out = esc(t); q.split(/\s+/).filter(function (x) { return x.length > 1; }).forEach(function (x) { out = out.replace(new RegExp('(' + x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); }); return out; }
  function money(v) { var n = parseFloat(v); if (isNaN(n)) return ''; return n.toLocaleString('en-US', { maximumFractionDigits: 0 }) + ' LE'; }
  function interpret(q) {
    var cfg = S.cfg, joined = ' ' + q.toLowerCase().replace(/[^a-z0-9&' -]/g, ' ') + ' ', jumps = [];
    var gender = /\b(women|woman|womens|women's|ladies|her)\b/.test(joined) ? 'women' : /\b(men|man|mens|men's|him)\b/.test(joined) ? 'men' : '';
    var brand = null; cfg.brands.forEach(function (b) { if (!brand && joined.indexOf(' ' + b[0].toLowerCase() + ' ') > -1) brand = b; });
    if (!brand) cfg.brands.forEach(function (b) { if (!brand && b[1].length > 3 && joined.indexOf(' ' + b[1].replace(/-/g, ' ') + ' ') > -1) brand = b; });
    var type = null; cfg.types.forEach(function (t) { if (!type && t[0].split('|').some(function (k) { return joined.indexOf(' ' + k + ' ') > -1 || joined.indexOf(' ' + k + 's ') > -1; })) type = t; });
    if (type && gender) { var gh = type[3] && type[3][gender]; if (gh) jumps.push([(gender === 'women' ? "Women's " : "Men's ") + type[1], '/collections/' + gh]); }
    if (type) jumps.push([type[1], '/collections/' + type[2]]);
    if (brand) jumps.push([brand[0], '/collections/' + brand[1]]);
    if (!type && gender) jumps.push([gender === 'women' ? 'Women' : 'Men', '/collections/' + gender]);
    return jumps;
  }
  function renderIdle() {
    var cfg = S.cfg, rec = store.get('mpx:rs');
    S.res.innerHTML = '<div class="mpx-search__col">' +
      (rec.length ? '<div class="mpx-search__grp"><h4>Recent searches</h4><ul class="mpx-search__list">' + rec.map(function (r) { return '<li><button type="button" data-q="' + esc(r) + '">' + esc(r) + '</button></li>'; }).join('') + '</ul></div>' : '') +
      '<div class="mpx-search__grp"><h4>Trending searches</h4><ul class="mpx-search__list">' + cfg.trending.map(function (r) { return '<li><button type="button" data-q="' + esc(r) + '">' + esc(r) + '</button></li>'; }).join('') + '</ul></div></div>' +
      '<div class="mpx-search__col"><div class="mpx-search__grp"><h4>Popular categories</h4><div class="mpx-search__chips">' + cfg.cats.map(function (c) { return '<a class="mpx-chip" href="/collections/' + c[1] + '">' + esc(c[0]) + '</a>'; }).join('') + '</div></div>' +
      '<div class="mpx-search__grp"><h4>Popular brands</h4><div class="mpx-search__chips">' + cfg.brands.slice(0, 12).map(function (b) { return '<a class="mpx-chip" href="/collections/' + b[1] + '">' + esc(b[0]) + '</a>'; }).join('') + '</div></div>' +
      '<div class="mpx-search__grp"><a class="mpx-link" href="/pages/brands">All brands A–Z <span class="mpx-arrow">→</span></a></div></div>';
  }
  function runSearch(q) {
    if (sCtl) sCtl.abort(); sCtl = 'AbortController' in w ? new AbortController() : null;
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url, sCtl ? { signal: sCtl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
      var R = (j.resources && j.resources.results) || {}, P = R.products || [], C = R.collections || [], Q = R.queries || [];
      var jumps = interpret(q), brandSet = {}; S.cfg.brands.forEach(function (b) { brandSet[b[1]] = 1; });
      var cats = C.filter(function (c) { return !brandSet[c.handle]; }).slice(0, 6), brands = C.filter(function (c) { return brandSet[c.handle]; }).slice(0, 4);
      var left = '';
      if (jumps.length) left += '<div class="mpx-search__grp"><h4>Jump to</h4><ul class="mpx-search__list">' + jumps.map(function (x) { return '<li><a href="' + x[1] + '">' + esc(x[0]) + ' →</a></li>'; }).join('') + '</ul></div>';
      if (Q.length) left += '<div class="mpx-search__grp"><h4>Suggestions</h4><ul class="mpx-search__list">' + Q.slice(0, 5).map(function (x) { return '<li><button type="button" data-q="' + esc(x.text) + '">' + (x.styled_text || esc(x.text)) + '</button></li>'; }).join('') + '</ul></div>';
      if (cats.length) left += '<div class="mpx-search__grp"><h4>Categories</h4><ul class="mpx-search__list">' + cats.map(function (c) { return '<li><a href="' + c.url + '">' + hl(c.title, q) + '</a></li>'; }).join('') + '</ul></div>';
      if (brands.length) left += '<div class="mpx-search__grp"><h4>Brands</h4><ul class="mpx-search__list">' + brands.map(function (c) { return '<li><a href="' + c.url + '">' + hl(c.title, q) + '</a></li>'; }).join('') + '</ul></div>';
      var right = P.length ? '<div class="mpx-search__grp"><h4>Products</h4><div class="mpx-search__prods">' + P.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=400' : (p.image || '');
        var cmp = parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + money(p.compare_at_price_max) + '</s>' : '';
        return '<a class="mpx-card" href="' + p.url + '"><div class="mpx-card__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div><div class="mpx-card__info"><div class="mpx-card__title" style="-webkit-line-clamp:2;color:var(--mpx-ink)">' + hl(clean(p.title).split(/\s[–—|]\s/)[0], q) + '</div><div class="mpx-card__price"><span' + (cmp ? ' class="is-sale"' : '') + '>' + money(p.price) + '</span>' + cmp + '</div></div></a>';
      }).join('') + '</div><div class="mpx-search__all"><a class="mpx-btn mpx-btn--solid" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results for “' + esc(q) + '” <span class="mpx-arrow">→</span></a></div></div>'
        : '<div class="mpx-search__grp"><h4>No exact matches</h4><p class="mpx-search__hint">Try a brand or a category — e.g. “Dior bag”, “men sneakers”, “sunglasses”.</p><div class="mpx-search__chips">' + S.cfg.cats.slice(0, 8).map(function (c) { return '<a class="mpx-chip" href="/collections/' + c[1] + '">' + esc(c[0]) + '</a>'; }).join('') + '</div></div>';
      S.res.innerHTML = '<div class="mpx-search__col">' + (left || '<p class="mpx-search__hint">Keep typing…</p>') + '</div><div class="mpx-search__col">' + right + '</div>';
    }).catch(function () {});
  }
  function searchInit() {
    S = { el: d.getElementById('MpxSearch') }; if (!S.el) return;
    try { S.cfg = JSON.parse(d.getElementById('MpxSearchCfg').textContent); } catch (e) { return; }
    S.input = S.el.querySelector('.mpx-search__input'); S.res = S.el.querySelector('[data-search-results]');
    function open(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation && e.stopImmediatePropagation(); }
      S.el.classList.add('is-open'); html.classList.add('mpx-lock'); S.el.setAttribute('aria-hidden', 'false');
      if (!S.input.value) renderIdle(); setTimeout(function () { S.input.focus(); }, 30);
    }
    function close() { S.el.classList.remove('is-open'); html.classList.remove('mpx-lock'); S.el.setAttribute('aria-hidden', 'true'); }
    S.open = open; S.close = close;
    d.addEventListener('click', function (e) {
      var t = e.target.closest('a[href="/search"], a[href^="/search?"]:not([href*="q="]), [aria-controls="SearchDrawer"], [aria-controls*="search" i], .header__search, [data-mpx-search-open], button[name="search"]');
      if (t && !t.closest('.mpx-search') && !t.closest('form')) open(e);
    }, true);
    S.el.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-close]')) { close(); return; }
      var qb = e.target.closest('[data-q]'); if (qb) { S.input.value = qb.dataset.q; S.input.dispatchEvent(new Event('input')); S.input.focus(); }
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && S.el.classList.contains('is-open')) close();
      if ((e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey))) && !/input|textarea|select/i.test((d.activeElement || {}).tagName || '')) open(e);
    });
    S.input.addEventListener('input', function () {
      var q = S.input.value.trim(); clearTimeout(sTimer);
      if (q.length < 2) { renderIdle(); return; }
      sTimer = setTimeout(function () { runSearch(q); }, 160);
    });
    S.el.querySelector('form').addEventListener('submit', function () {
      var q = S.input.value.trim(); if (!q) return;
      var rec = store.get('mpx:rs').filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); rec.unshift(q); store.set('mpx:rs', rec.slice(0, 5));
    });
  }

  /* ---------- reveal ---------- */
  function reveal() {
    if (reduce || !('IntersectionObserver' in w) || (w.Shopify && w.Shopify.designMode)) { d.querySelectorAll('.mpx-reveal').forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    d.querySelectorAll('.mpx-reveal').forEach(function (el) { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-in'); else io.observe(el); });
    setTimeout(function () { d.querySelectorAll('.mpx-reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 5000);
  }

  function init(root) { (root || d).querySelectorAll('.mpx-rail').forEach(rail); feeds(root); explorer(); cards_(root); recent(); }
  function boot() { header(); trackView(); searchInit(); init(); reveal(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); reveal(); });
  w.MPX = { init: init, openSearch: function () { S && S.open && S.open(); }, refreshCart: refreshCart };
})();
